module.exports = __webpack_public_path__ + "static/WelcomeToElk7-dc09a79934c4e98275980695303b3d05.webp";